function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgPodium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.989 511.989",
    style: {
      enableBackground: "new 0 0 511.989 511.989"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BB42"
    },
    d: "M255.994,213.336c-5.906,0-10.672-4.781-10.672-10.672v-42.663c0-5.891,4.766-10.664,10.672-10.664 c5.874,0,10.655,4.773,10.655,10.664v42.663C266.649,208.555,261.868,213.336,255.994,213.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M309.321,192h-106.67c-5.891,0-10.656,4.773-10.656,10.664v42.671 c0,5.891,4.765,10.664,10.656,10.664h106.67c5.891,0,10.672-4.773,10.672-10.664v-42.671C319.993,196.774,315.212,192,309.321,192z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(226, 136, 23)"
    },
    d: "M479.989,362.653H330.648c-5.891,0-10.655,4.781-10.655,10.688v106.652 c0,5.891,4.765,10.656,10.655,10.656h149.341c5.875,0,10.656-4.766,10.656-10.656V373.341 C490.645,367.434,485.864,362.653,479.989,362.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(203, 203, 203)"
    },
    d: "M181.324,319.997H31.999c-5.906,0-10.671,4.781-10.671,10.656v149.34 c0,5.891,4.765,10.656,10.671,10.656h149.325c5.891,0,10.672-4.766,10.672-10.656v-149.34 C191.995,324.778,187.214,319.997,181.324,319.997z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M330.648,234.663H181.324c-5.891,0-10.671,4.781-10.671,10.672v234.658 c0,5.891,4.781,10.656,10.671,10.656h149.325c5.891,0,10.672-4.766,10.672-10.656V245.335 C341.32,239.445,336.539,234.663,330.648,234.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M501.316,490.649H10.656C4.765,490.649,0,485.883,0,479.993s4.765-10.654,10.656-10.654h490.661 c5.891,0,10.672,4.764,10.672,10.654S507.207,490.649,501.316,490.649z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BB42"
    },
    d: "M200.542,138.674c-1.234,0-2.5-0.219-3.734-0.688c-46.717-17.515-57.577-80.256-58.014-82.912 c-0.5-3.094,0.375-6.25,2.391-8.641c2.031-2.382,5-3.765,8.141-3.765h42.671c5.875,0,10.656,4.781,10.656,10.671 s-4.781,10.664-10.656,10.664h-29.046c5.016,16.555,16.921,44.851,41.343,54.015c5.516,2.062,8.312,8.211,6.25,13.727 C208.932,136.025,204.87,138.674,200.542,138.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BB42"
    },
    d: "M311.415,138.674c-4.312,0-8.375-2.648-9.984-6.929c-2.062-5.516,0.734-11.664,6.25-13.727 c24.546-9.211,36.404-37.476,41.373-54.015h-29.061c-5.906,0-10.672-4.773-10.672-10.664s4.766-10.671,10.672-10.671h42.654 c3.141,0,6.109,1.383,8.141,3.765c2.016,2.391,2.891,5.547,2.391,8.641c-0.438,2.656-11.297,65.397-58.014,82.912 C313.931,138.455,312.665,138.674,311.415,138.674z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M319.993,21.34H191.995c-5.906,0-10.672,4.773-10.672,10.664v63.999 c0,41.171,33.483,74.663,74.67,74.663c41.155,0,74.654-33.492,74.654-74.663V32.004C330.648,26.114,325.867,21.34,319.993,21.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8AA3D"
    },
    d: "M255.994,117.338c-5.906,0-10.672-4.781-10.672-10.672V74.667c0-5.891,4.766-10.664,10.672-10.664 c5.874,0,10.655,4.773,10.655,10.664v31.999C266.649,112.557,261.868,117.338,255.994,117.338z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.ef824da6.svg";
export { ForwardRef as ReactComponent };